import { render, staticRenderFns } from "./club-main.vue?vue&type=template&id=450355c4&scoped=true&"
import script from "./club-main.vue?vue&type=script&lang=js&"
export * from "./club-main.vue?vue&type=script&lang=js&"
import style0 from "./club-main.vue?vue&type=style&index=0&id=450355c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450355c4",
  null
  
)

export default component.exports